// import React, { useMemo, useState } from "react";
// import ReactApexChart from "react-apexcharts";
// import {getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
//   currencyFormatWithoutDecimalV1,
//   getDateByNameV1
// } from "../../helpers/api_helper";
// import { postDataAPI } from "../../helpers/phpbackend_helper";

// const LocationChartCovers = ({rightFilter, comparisonDate, leftFilter, mealPeriod, refresh, leftCustomDate, widgetDetailGroupId}) => {
//   // Generate consistent dummy data on initial render
//   console.log("Params");
//   console.log(widgetDetailGroupId);
//   const [loading, setLoading] = useState(false);
  
//   const convertDateRange = (filter, customDate) =>
//     filter === 'Custom'
//         ? { from: convertDateFormate(customDate[0]), to: convertDateFormate(customDate[1]), from_date: convertDateFormate(customDate[0]), to_date: convertDateFormate(customDate[1]) }
//         : getDateByNameV1(filter);

//   const leftFilterDate = convertDateRange(leftFilter.value, leftCustomDate)
//   // Date Logic
//   const startDate = new Date(leftFilterDate.from_date);
//   const endDate = new Date(leftFilterDate.to_date);
//   const customlabels = [];
//   let currentDate = new Date(startDate);
//   while (currentDate <= endDate) {
//       const day = currentDate.toLocaleString('en-us', { day: '2-digit' });
//       const month = currentDate.toLocaleString('en-us', { month: 'short' });
//       customlabels.push(`${day}-${month}`);
//       currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
//   }


//   const {
//     coversThisYear,
//     coversLastYear,
//     avgCheckThisYear,
//     avgCheckLastYear,
//     revPashThisYear,
//     revPashLastYear,
//     days
//   } = useMemo(async () => {
//     // const getRandomArray = (count, max) =>
//     //   Array.from({ length: count }, () => Math.floor(Math.random() * max));

//     // const getRandomFloatArray = (count, max) =>
//     //   Array.from({ length: count }, () => parseFloat((Math.random() * max).toFixed(2)));

//     // return {
//     //   coversThisYear: getRandomArray(30, 800),
//     //   coversLastYear: getRandomArray(30, 800),
//     //   avgCheckThisYear: getRandomFloatArray(30, 60),
//     //   avgCheckLastYear: getRandomFloatArray(30, 60),
//     //   revPashThisYear: getRandomFloatArray(30, 60),
//     //   revPashLastYear: getRandomFloatArray(30, 60),
//     //   days: Array.from({ length: 30 }, (_, i) => `${i + 1}`)
//     // };
//     setLoading(true);
//     const res = {
//       coversThisYear: [],
//       coversLastYear:[],
//       avgCheckThisYear: [],
//       avgCheckLastYear: [],
//       revPashThisYear: [],
//       revPashLastYear: [],
//     }

//     const payload = {
//         serviceName: 'kpi_data',
//         op: 'flash_kpi_forecast',
//         group_id: widgetDetailGroupId,
//         leftFilter: leftFilterDate,
//         rightFilter: convertDateRange(rightFilter.value, comparisonDate),
//         mealPeriod: mealPeriod ? [mealPeriod]: [],
//     };
//     const response = await postDataAPI(payload);
//     console.log(response);
//     if(response.status === 'ok') {
//       setLoading(false);
//       const results = response.data.data || "";
//       console.log("Before ");
//       console.log(results);
//       if (results) {
//         res.coversThisYear = results.covers;
//         res.coversLastYear = results.covers_lastyear;
//         res.avgCheckThisYear = results.average_check;
//         res.avgCheckLastYear = results.average_check_lastyear;
//         res.revPashThisYear = results.revPASH;
//         res.revPashLastYear = results.revPASH_lastyear;
//         console.log("After ");
        
//         console.log(res);
//         return res;
//       } else {
//         return res;
//       }
//     } else {
//       setLoading(false);
//       console.log(response);
//       return res;
//     }
//     //return response.status === 'ok' ? response.data || [] : [];
//   }, [rightFilter, comparisonDate, leftFilter, mealPeriod, refresh, leftCustomDate]);

//   const series = [
//     {
//       name: "Covers (This Year)",
//       type: "column",
//       data: coversThisYear
//     },
//     {
//       name: "Covers (Last Year)",
//       type: "column",
//       data: coversLastYear
//     },
//     {
//       name: "Avg Check (This Year)",
//       type: "line",
//       data: avgCheckThisYear
//     },
//     {
//       name: "Avg Check (Last Year)",
//       type: "line",
//       data: avgCheckLastYear
//     },
//     {
//       name: "RevPASH (This Year)",
//       type: "line",
//       data: revPashThisYear
//     },
//     {
//       name: "RevPASH (Last Year)",
//       type: "line",
//       data: revPashLastYear
//     }
//   ];

//   const options = {
//     chart: {
//       stacked: false,
//       toolbar: { show: false }
//     },
//     stroke: {
//       width: [0, 0, 2, 2, 2, 2]
//     },
//     xaxis: {
//       categories: customlabels
//     },
//     dataLabels: {
//         enabled: false,
//         //enabledOnSeries: [0, 0] // Show only for bars
//     },
//     markers: {
//         size: 4, // Show small circles on line points
//     },
//     colors: [
//       "#007bff", // Covers (This Year)
//       "#6f42c1", // Covers (Last Year)
//       "#dc3545", // Avg Check (This Year)
//       "#fd7e14", // Avg Check (Last Year)
//       "#20c997", // RevPASH (This Year)
//       "#198754"  // RevPASH (Last Year)
//     ],
//     yaxis: [
//       {
//         seriesName: "Covers (This Year)",
//         title: { text: "Covers" },
//         min: 0,
//         max: 800,
//         tickAmount: 8,
//         labels: { formatter: val => val.toFixed(0) }
//       },
//       {
//         show: false
//       },
//       {
//         opposite: true,
//         title: { text: "Avg Check & RevPASH" },
//         min: 0,
//         max: 60,
//         tickAmount: 6,
//         labels: { formatter: val => val.toFixed(2) }
//       }
//     ],
//     tooltip: {
//       shared: true,
//       intersect: false,
//       followCursor: true,
//       y: {
//         formatter: function (value, { seriesIndex }) {
//           return [0, 1].includes(seriesIndex) ? value.toFixed(0) : value.toFixed(2);
//         }
//       }
//     },
//     legend: {
//       position: "bottom",
//       horizontalAlign: "center"
//     }
//   };

//   return (
//     <>
//       {loading ? (
//         <>Loading...</>
//       ) : (
//         <ReactApexChart options={options} series={series} type="line" height={400} />
//       )}
//     </>
//   );
  
// };

// export default LocationChartCovers;


import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import {
  convertDateFormate,
  getDateByNameV1,
} from "../../helpers/api_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import Loader from "../../Components/Common/Loader";

const LocationChartCovers = ({
  leftFilter,
  mealPeriod,
  widgetDetailGroupId
}) => {
  const [loading, setLoading] = useState(false);
  const [series, setSeries] = useState([]);
  const [customLabels, setCustomLabels] = useState([]);

  // Convert date range helper
  const convertDateRange = (filter, customDate) =>
    filter === "Custom"
      ? {
          from: convertDateFormate(customDate[0]),
          to: convertDateFormate(customDate[1]),
          from_date: convertDateFormate(customDate[0]),
          to_date: convertDateFormate(customDate[1]),
        }
      : getDateByNameV1(filter);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      //const leftFilterDate = convertDateRange(leftFilter.value, leftCustomDate);      

      const payload = {
        serviceName: "kpi_data",
        op: "flash_kpi_forecast",
        group_id: widgetDetailGroupId,
        leftFilter: leftFilter,
        mealPeriod: mealPeriod,
      };

      const response = await postDataAPI(payload);
      const res = {
        coversThisYear: [],
        coversLastYear: [],
        avgCheckThisYear: [],
        avgCheckLastYear: [],
        revPashThisYear: [],
        revPashLastYear: [],
      };

      if (response.status === "ok") {
        const results = response.data.data || {};
        res.coversThisYear = results.covers || [];
        res.coversLastYear = results.covers_lastyear || [];
        res.avgCheckThisYear = results.average_check || [];
        res.avgCheckLastYear = results.average_check_lastyear || [];
        res.revPashThisYear = results.revPASH || [];
        res.revPashLastYear = results.revPASH_lastyear || [];


        // Create date labels for X-axis
        //if(results?.covers) {
        const startDate = new Date(results.start_dt);
        const labels = [];
        if(results?.covers) {
          const totalDays = results.covers.length; // assumes `covers` is defined and is an array

          let currentDate = new Date(startDate);

          for (let i = 0; i < totalDays; i++) {
            const day = currentDate.toLocaleString("en-us", { day: "2-digit" });
            const month = currentDate.toLocaleString("en-us", { month: "short" });
            labels.push(`${day}-${month}`);
            currentDate.setDate(currentDate.getDate() + 1);
          }
        }
        setCustomLabels(labels);
      }

      setSeries([
        {
          name: "Covers (This Year)",
          type: "column",
          data: res.coversThisYear,
        },
        {
          name: "Covers (Last Year)",
          type: "column",
          data: res.coversLastYear,
        },
        {
          name: "Avg Check (This Year)",
          type: "line",
          data: res.avgCheckThisYear,
        },
        {
          name: "Avg Check (Last Year)",
          type: "line",
          data: res.avgCheckLastYear,
        },
        {
          name: "RevPASH (This Year)",
          type: "line",
          data: res.revPashThisYear,
        },
        {
          name: "RevPASH (Last Year)",
          type: "line",
          data: res.revPashLastYear,
        },
      ]);

      setLoading(false);
    };

    fetchData();
  }, [leftFilter, mealPeriod, widgetDetailGroupId]);

  const options = {
    chart: {
      stacked: false,
      toolbar: { show: false },
    },
    stroke: {
      width: [0, 0, 2, 2, 2, 2],
    },
    xaxis: {
      categories: customLabels,
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 4,
    },
    colors: [
      "#007bff",
      "#6f42c1",
      "#dc3545",
      "#fd7e14",
      "#20c997",
      "#198754",
    ],
    yaxis: [
      {
        seriesName: "Covers (This Year)",
        title: { text: "Covers" },
        min: 0,
        tickAmount: 8,
        labels: {
          formatter: function (val) {
            return typeof val === 'number' ? val.toFixed(0) : '0';
          }
        }
      },
      {
        show: false,
        title: { text: "" },
        labels: { show: false }
      },
      {
        opposite: true,
        title: { text: "Avg Check & RevPASH" },
        min: 0,
        tickAmount: 6,
        labels: {
          formatter: function (val) {
            return typeof val === 'number' ? val.toFixed(0) : '0';
          }
        }
      },
    ],
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    //   followCursor: true,
    //   y: {
    //     formatter: function (value, { seriesIndex }) {
    //       if (value == null || isNaN(value)) return '-';
    //       return [0, 1].includes(seriesIndex) ? value.toFixed(0) : value.toFixed(2);
    //     }
    //   }
    // },    
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
  };

  return (
    <>

      {loading && <Loader />}    
      <div className={loading ? "opacity-0" : ""}>
      <ReactApexChart options={options} series={series} type="line" height={400} />
      </div>

    </>
  );
};

export default LocationChartCovers;
